import { ToggleButton, type ToggleButtonProps } from '@mui/material';
import { forwardRef } from 'react';

/** A single segment within a `VyToggleButtonGroup`. Styling lives in the `MuiToggleButton` theme override. */
export type VyToggleButtonProps = ToggleButtonProps;

export const VyToggleButton = forwardRef<HTMLButtonElement, VyToggleButtonProps>(
  function VyToggleButton(props, ref) {
    return <ToggleButton ref={ref} {...props} />;
  },
);
